import { useMemo } from 'react'
import { connect } from 'react-redux';
import {
  Name,
  LockedLabel,
  Flex,
  CategoryHeaderRow,
} from './styles'
import Icon from '../../../../../components/Icon';
import ViewMoreButton from '../ViewMoreButton'
import padlockLockIcon from '../../../../../assets/icons/padlock-lock.svg'
import { useWindowSize } from '../../../../../hooks/useWindowSize';
import { CategoryDto } from '../../../../../types/category';
import { roundedHumanUnlockTime } from '../../../../../helpers/humanUnlockTime';
import UnlockedCategoryMedal from '../../../../components/UnlockedCategoryMedal';

interface ComponentProps {
  category: CategoryDto
}

const CategoryHeader = ({
  category,
}: ComponentProps) => {
  const { isMobile } = useWindowSize()

  const humanReadableTime = useMemo(() => {
    return roundedHumanUnlockTime(category)
  }, [category]);

  return (
    <CategoryHeaderRow>
      <Flex style={{ justifyContent: isMobile ? "space-between" : "flex-start", width: '100%' }}>
        {!isMobile && category?.is_unlockable && category?.locked_ordinal && (
          <UnlockedCategoryMedal category={category} width="32px" height="auto" />
        )}

        <Name>{category?.name}</Name>

        {!isMobile && humanReadableTime && (
          <LockedLabel>
            {!category?.user_access_data?.is_unlocked && <Icon icon={padlockLockIcon} size="16px" color="#93410F" />}
            {humanReadableTime}
          </LockedLabel>
        )}

        {isMobile && (
          <Flex>
            <ViewMoreButton category={category} />
          </Flex>
        )}
      </Flex>

      {!isMobile && (
        <Flex>
          <ViewMoreButton category={category} />
        </Flex>
      )}

      {isMobile && category?.is_unlockable && (
        <Flex>
          {category?.locked_ordinal && (
            <UnlockedCategoryMedal category={category} width="32px" height="auto" />
          )}

          {humanReadableTime && (
            <LockedLabel>
              {!category?.user_access_data?.is_unlocked && <Icon icon={padlockLockIcon} size="16px" color="#93410F" />}
              {humanReadableTime}
            </LockedLabel>
          )}
        </Flex>
      )}
    </CategoryHeaderRow>
  )
}

const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates
  };
};

export default connect(state)(CategoryHeader);